import { initARMS, setUserInfo } from '@patsnap-utils/ali-arms';
import type { AilArmsParams } from '../types/arms';


export const loadAilArms = (params: AilArmsParams) => {
    initARMS({
        pid: process.env.VUE_APP_ARMS_PID || '',
        endpoint: process.env.VUE_APP_ARMS_ENDPOINT || '',
        spaMode: params.spaMode,
    });


    if (params.account_id) {
        setUserInfo({
            patsnapUserId: params.account_id,
        });
    }

}
